import { useEffect, useState } from 'react'

// Function to get UTM parameters from the URL
function getUTMParameters() {
  var params = {}
  var urlParams = new URLSearchParams(window.location.search)
  urlParams.forEach(function (value, key) {
    if (key.startsWith('utm_')) {
      params[key] = value
    }
  })
  return params
}

function getGA4ClientId() {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('_ga='));

  if (cookie) {
    const parts = cookie.split('=');
    const clientId = parts[1].split('.').slice(2).join('.');
    return clientId;
  }
  return null;
}

// Function to append UTM parameters to the Thank you page redirect URL
function appendUTMParameters(url, params) {
  var urlObj = new URL(url)
  Object.keys(params).forEach(function (key) {
    urlObj.searchParams.set(key, params[key])
  })
  return urlObj.toString()
}

let scriptsAdded = false
function appendScript(baseUrl, setScriptLoaded) {
  if (window.MktoForms2) return setScriptLoaded(true)
  else if (scriptsAdded) return
  const mkoFormScript = document.createElement('script')
  const formEnhancementScript = document.createElement('script')

  formEnhancementScript.src = '//cdn-0.d41.co/tags/ff-2.min.js'
  mkoFormScript.src = `${baseUrl}/js/forms2/js/forms2.min.js`

  mkoFormScript.onload = () => {
    if (window.MktoForms2) {
      window.MktoForms2.whenReady(function (form) {
        // Get all URL params and add as hidden field in Marketo form
        var utmParams = getUTMParameters()
        if (Object.keys(utmParams).length > 0) {
          Object.keys(utmParams).forEach(function (key) {
            var hiddenField = document.createElement('input')
            hiddenField.type = 'hidden'
            hiddenField.name = key
            hiddenField.value = utmParams[key]
            document.querySelector('form.mktoForm').appendChild(hiddenField)
          })
        }

        // Set the GA Client ID in the Marketo form
        const clientId = getGA4ClientId();
        if (clientId) {
          form.setValues({
            'GACLIENTID__c': clientId
          });
        } else {
          console.warn('GA Client ID not found in _ga cookie');
        }

        const globalScript = document.createElement('script')
        globalScript.src = '//start.uipath.com/rs/995-XLT-886/images/Global_js.js'
        document.body.appendChild(globalScript)
        let noOfSubmits = 0

        let pageForm = document.querySelector('.MarketoForm form')
        // 6si tracking on submit
        pageForm.addEventListener(
          'submit',
          e => {
            if (window._6si) {
              window._6si.send(e)
            }
          },
          false
        )

        form.onSubmit(form => {
          setTimeout(() => {
            let path = window.location.pathname
            // Do not re-submit the form if the user is on a thank you page
            if (path.startsWith('/g/thank-you-') || path.startsWith('/thank-you-')) {
              return
            }

            if (noOfSubmits < 2) {
              if ('ga' in window) {
                // name of GA tracker: gtag_UA_39012418_20
                ga('gtag_UA_39012418_20.send', {
                  hitType: 'event',
                  eventCategory: 'Form Submit',
                  eventAction: 'mktoForm',
                  eventLabel: 'Form Delay',
                })
              }
              // Attempt a resubmit twice after the form delay
              form.submit()
              noOfSubmits++
            } else {
              form.showErrorMessage('Submission error. Please refresh this page and try again.')
            }
          }, 5000)
        })
      })

      setScriptLoaded(true)
    }
  }

  document.body.appendChild(mkoFormScript)
  document.body.appendChild(formEnhancementScript)
  scriptsAdded = true
}

function useMarketo({ baseUrl, munchkinId, formId, callback, marketoJsScript }) {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  useEffect(() => {
    if (scriptLoaded) {
      if (!marketoJsScript) {
        window.MktoForms2.loadForm('//start.uipath.com', munchkinId, formId, callback)
      } else {
        try {
          eval(marketoJsScript)
        } catch (e) {
          console.error('Invalid marketoJsScript from Contentful: ', e)
          // Fallback to the default form
          window.MktoForms2.loadForm('//start.uipath.com', munchkinId, formId, callback)
        }
      }
    } else {
      appendScript(baseUrl, setScriptLoaded)
    }
  }, [scriptLoaded])
}

export default useMarketo
